module.exports = __webpack_public_path__ + "static/media/chick.bfd23e6c.JPG";